import React, { useState } from 'react';

const roleColors = {
  S: { bg: 'bg-blue-500', dot: 'bg-blue-500' },
  V: { bg: 'bg-green-500', dot: 'bg-green-500' },
  O: { bg: 'bg-amber-500', dot: 'bg-amber-500' },
};

const roleLabels = { S: 'Podmět', V: 'Přísudek', O: 'Předmět' };

const SVOPanel = ({ exercise }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!exercise?.svo_analysis?.en || !exercise?.svo_analysis?.cs) return null;

  const renderBubbles = (parts) =>
    parts.map((part, i) => (
      <span
        key={i}
        className={`${roleColors[part.role]?.bg || 'bg-gray-400'} text-white px-2.5 py-1 rounded-full text-sm font-medium mx-0.5 inline-block`}
      >
        {part.text}
      </span>
    ));

  return (
    <div className="mt-2 w-full">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="text-xs text-purple-600 hover:text-purple-800 hover:underline transition-colors"
      >
        {isOpen ? 'Skrýt slovosled' : 'Zobrazit slovosled'}
      </button>
      {isOpen && (
        <div className="mt-2 p-3 bg-gray-50 rounded-lg text-sm space-y-2 border border-gray-200">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="font-semibold text-gray-500 w-8">EN:</span>
            {renderBubbles(exercise.svo_analysis.en)}
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <span className="font-semibold text-gray-500 w-8">CZ:</span>
            {renderBubbles(exercise.svo_analysis.cs)}
          </div>
          <div className="flex gap-3 text-xs text-gray-400 pt-1 border-t border-gray-200">
            {Object.entries(roleLabels).map(([role, label]) => (
              <span key={role} className="flex items-center gap-1">
                <span className={`w-2 h-2 rounded-full ${roleColors[role].dot}`}></span>
                {label}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SVOPanel;
